<template>
  <organization-users :organization-slug="organizationSlug" :load-event-templates="true" />
</template>

<script>
import OrganizationUsers from './organization-users.vue'

export default {
  name: 'theater-organization-users',
  components: {
    OrganizationUsers,
  },
  props: {
    organizationSlug: {
      type: String,
      required: true,
    },
  },
}
</script>
